module.exports = __webpack_public_path__ + "img/Calendar-Holiday.80f7c591.svg";